export default __webpack_public_path__ + "static/media/logo-optimized.de2a760b.webp";